import React, { useState, useEffect } from 'react';
import { 
  View, 
  Text, 
  StyleSheet, 
  TouchableOpacity, 
  Dimensions, 
  Platform,
  Linking,
  DeviceEventEmitter
} from 'react-native';
import PlatformDetector from '../../../utils/PlatformDetector';
import { colores } from '../../../styles/variablesCss';
import Storage from '../../../utils/Storage';

// Obtener dimensiones iniciales
const { width: initialWidth } = Dimensions.get('window');
// Detectar si estamos en móvil web (no en app nativa)
const isMobileWeb = Platform.OS === 'web' && initialWidth < 768;
const isMobile = PlatformDetector.isMobile() || isMobileWeb;

const FormularioContacto = () => {
  // Estado para manejar el ancho de la pantalla de manera responsiva
  const [viewportWidth, setViewportWidth] = useState(initialWidth);
  const [ciudad, setCiudad] = useState(null);
  
  // Efecto para actualizar el ancho cuando cambia el tamaño de la ventana (solo en web)
  useEffect(() => {
    if (Platform.OS === 'web') {
      const handleResize = () => {
        setViewportWidth(window.innerWidth);
      };
      
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
  }, []);
  
  // Cargar ciudad desde Storage
  useEffect(() => {
    const loadCiudad = async () => {
      try {
        const storedCiudad = await Storage.getItem('ciudad');
        setCiudad(storedCiudad ? Number(storedCiudad) : null);
      } catch (e) {
        console.log('Error cargando ciudad:', e);
        setCiudad(null);
      }
    };
    loadCiudad();

    // Escuchar cambios en la ciudad
    if (Platform.OS === 'web' && typeof window !== 'undefined') {
      const handleStorageChange = (e) => {
        if (e?.detail?.key === 'ciudad' || e?.detail?.key === 'ciudadNom' || e?.detail?.key === 'sucursalId') {
          loadCiudad();
        }
      };

      window.addEventListener('localStorageChange', handleStorageChange);
      return () => {
        window.removeEventListener('localStorageChange', handleStorageChange);
      };
    } else {
      // En móvil, escuchar evento de cambio de sucursal
      const subscription = DeviceEventEmitter?.addListener?.('sucursalChanged', () => {
        loadCiudad();
      });

      return () => {
        if (subscription?.remove) subscription.remove();
      };
    }
  }, []);
  
  // Determinar si estamos en modo móvil basado en el ancho actual
  const isCurrentlyMobile = viewportWidth < 768;

  const handleMeSumo = () => {
    // Links de WhatsApp según ciudad
    const whatsappLinks = {
      1: 'https://whatsapp.com/channel/0029VbCIduRLo4hhznDAXm3M',
      2: 'https://whatsapp.com/channel/0029VbBqZPGKQuJQHSDyJV02'
    };
    
    // Usar link de ciudad 1 por defecto si no hay ciudad seleccionada
    const link = whatsappLinks[ciudad] || whatsappLinks[1];
    
    if (Platform.OS === 'web') {
      window.open(link, '_blank', 'noopener,noreferrer');
    } else {
      Linking.openURL(link);
    }
  };

  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <View style={styles.textContainer}>
          <Text style={styles.title}>RECIBÍ LAS OFERTAS</Text>
          <Text style={styles.title}>EN TU CELULAR</Text>
          <Text style={styles.subtitle}>Sumate a nuestro canal</Text>
          <Text style={styles.subtitle}>de difusión en Whatsapp</Text>
        </View>
        
        <View style={styles.buttonContainer}>
          <TouchableOpacity
            style={styles.submitButton}
            onPress={handleMeSumo}
          >
            <Text style={styles.submitButtonText}>¡Me sumo!</Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    backgroundColor: colores.blanco,
    marginVertical: 15,
    padding: 20,
    borderRadius: 5,
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  },
  content: {
    flexDirection: isMobile ? 'column' : 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  textContainer: {
    width: isMobile ? '100%' : '35%',
    marginBottom: isMobile ? 20 : 0,
    alignItems: isMobile ? 'center' : 'flex-start'
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    color: colores.rojo,
    marginBottom: 2
  },
  subtitle: {
    fontSize: 16,
    color: colores.grisClaro,
    marginTop: 5
  },
  buttonContainer: {
    width: isMobile ? '100%' : '60%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  submitButton: {
    backgroundColor: colores.rojo,
    paddingVertical: 10,
    paddingHorizontal: 50,
    borderRadius: 5,
    alignItems: 'center',
    minWidth: isMobile ? '80%' : 300,
    ...(Platform.OS === 'web' ? { cursor: 'pointer' } : {}),
  },
  submitButtonText: {
    color: colores.blanco,
    fontSize: 22,
    fontWeight: 'bold'
  }
});

export default FormularioContacto;
